import dayjs from '@/shared/lib/dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isSameOrAfter);

export function formatDateLabel(date: dayjs.Dayjs) {
    const tomorrow = dayjs().add(1, 'day');
  
    const title = date.isSame(tomorrow, 'day')
      ? 'Завтра'
      : date.format('dd');
  
    return {
      title,
      date: date.format('DD.MM'),
    };
}